import React, { Component } from "react";
import Error from "./error";

let colleges_url = "";

class CollegesAndSchools extends Component {
  constructor(props) {
    super(props);
    this.state = {
      cas: [],
      loading: true,
      error: false
    };
  }

  /* */
  componentDidMount() {
    switch (window.location.hostname) {
      case "react.drup2-dev.uvm.edu":
      case "localhost":
        colleges_url = 'https://content.drup2-dev.uvm.edu/shared/json/taxonomy/colleges';
        break;
      case "react.drup2-staging.uvm.edu":
        colleges_url = 'https://content.drup2-staging.uvm.edu/shared/json/taxonomy/colleges';
        break;
      default:
        colleges_url = 'https://www.uvm.edu/content/shared/json/taxonomy/colleges';
    }

    fetch(colleges_url)
      .then(response => {
        return response.json();
      })
      .then(data => {
        this.setState({
          cas: data.data.tree,
        });
      })
      .catch(error => this.setState({ loading: false, error }));
  }

  /* */
  renderItems() {
    if (!this.state.error && this.state.cas.length > 0) {
      return this.state.cas.map((item, i) => (
        item.name !== "No College/School" ? (
          <div key={i} className="linkContainer">
            <a
              id = {"c" + i}
              href = {item.field_link.url}
              className = "tab"
              tabIndex = "0"
              style = {{
                color: "#000",
                textDecoration: "none",
                fontSize: "1.25em",
              }}
            >
              {item.name}
            </a>
          </div>
        ) : null
      ));
    } else {
      return <Error />;
    }
  }

  render() {
    return (
      <div
        className="Colsc"
        style={{
          marginLeft: "0",
          width: "100%",
          backgroundColor: "transparent"
        }}
      >
        <div
          className="backGroundColorBlock"
          style={{
            width: "100%",
            margin: "0 1em"
          }}
        >
          <h2
            className="degree-type"
            styles={{
              height: "32px",
              color: "#000",
              fontFamily: "Roboto",
              fontSize: "34px",
              lineHeight: "30px"
            }}
          >UVM Academic Colleges and Schools</h2>
          <div
            className="allDegrees"
            style={{
              paddingBottom: "6.25em",
              paddingTop: "36px",
              WebkitColumnCount: "2",
              columnCount: window.innerWidth > 899 ? "2" : "1",
              WebkitColumnGap: "1em",
              columnGap: "1em"
            }}
          >
            <div
              className="degree"
              style={{
                color: "rgba(0, 0, 0, 0.87)",
                fontSize: "0.875rem",
                fontWeight: "400",
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                lineHeight: "1.46429em"
              }}
            >{this.renderItems()}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default CollegesAndSchools;
